import { render, staticRenderFns } from "./fs-button-main.vue?vue&type=template&id=55e90e90&scoped=true"
import script from "./fs-button-main.vue?vue&type=script&lang=js"
export * from "./fs-button-main.vue?vue&type=script&lang=js"
import style0 from "./fs-button-main.vue?vue&type=style&index=0&id=55e90e90&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e90e90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55e90e90')) {
      api.createRecord('55e90e90', component.options)
    } else {
      api.reload('55e90e90', component.options)
    }
    module.hot.accept("./fs-button-main.vue?vue&type=template&id=55e90e90&scoped=true", function () {
      api.rerender('55e90e90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/buttons/fs-button-main.vue"
export default component.exports